import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquarePlus } from "lucide-react";
import { NewTicket } from "@/pages/Tickets";

export const ReportButton = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="report-fab-button"
        className="fixed right-4 bottom-20 md:bottom-6 z-40 bg-[#E3FF00] text-neutral-900 font-semibold px-4 py-3 rounded-full shadow-lg border border-neutral-900/10 hover:brightness-95 hover:-translate-y-0.5 transition-[transform,filter] inline-flex items-center gap-2 no-print">
        <MessageSquarePlus className="h-4 w-4" /> Segnalazione
      </button>
      {open && <NewTicket onClose={() => setOpen(false)} onCreated={() => { setOpen(false); navigate("/support"); }} />}
    </>
  );
};
